import React from 'react';
import { useTranslation } from 'react-i18next';
import { BarChartItem } from './AssessmentPDFDocument';

interface BarChartProps {
  data: BarChartItem[];
}

export const BarChart: React.FC<BarChartProps> = ({ data }) => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <h3 className="text-sm font-semibold text-center mb-4">{t('assessmentPDF.performanceMetrics')}</h3>
      <div className="space-y-3">
        {data.map((item: BarChartItem, index: number) => (
          <div key={index} className="flex items-center gap-3">
            <span className="text-xs w-16 text-gray-600">{t(`assessmentPDF.metrics.${item.label.toLowerCase()}`)}</span>
            <div className="flex-1 bg-gray-200 rounded-full h-3">
              <div 
                className="bg-assessment-green h-3 rounded-full transition-all duration-500"
                style={{ width: `${item.value}%` }}
              />
            </div>
            <span className="text-xs w-8 text-gray-600">{item.value}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}; 